import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { RootState } from "app/store";
import { BackToCourseTop } from "features/courses/components";
import { NishishinjukuGameMainPage } from "./NishishinjukuGameMainPage";
import { NishishinjukuCameraGameMainPage } from "./NishishinjukuCameraGameMainPage";

export const NishishinjukuGamePage = () => {
  const { stageId, stepId } = useParams<{
    stageId?: string;
    stepId?: string;
  }>();
  const step = Number(stepId);
  const stage = Number(stageId);
  const isCamera = useSelector((state: RootState) => state.courses.isCamera);
  return isNaN(stage) || isNaN(step) || stage > 4 || step > 3 ? (
    <BackToCourseTop />
  ) : isCamera ? (
    <NishishinjukuCameraGameMainPage stage={stage} step={step} />
  ) : (
    <NishishinjukuGameMainPage stage={stage} step={step} />
  );
};
